<template>
	<div>
		<iframeItem :urlPath="urlPath" is-no-container @onReadyLoad="onReadyLoad"></iframeItem>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'
import iframeItem from '@/components/iframe/iframeItem'
import {mapGetters} from 'vuex'
import {MessageEventType} from '@/util/channelUtil'
import {payToHint} from '@/util/insureUtils'
import {EnumInsureUrlType} from '@/const/enum'
import {getQueryObj} from '@/util/util'
import {isBxJtMsg} from '@/config/env'

export default {
	name: 'entryCenterUrl',
	mixins: [],
	components: {
		iframeItem,
	},
	props: {
		iframeUrl: String,
	},
	data() {
		return {
			urlPath: '',
		}
	},
	computed: {
		...mapGetters(['access_token', 'refresh_token']),
	},
	watch: {},
	created() {
		this.onGetUrlPath()
	},
	mounted() {},
	methods: {
		//获取URL
		onGetUrlPath() {
			//获取缓存 http://localhost:8080/#/tmk/task?referrer=ie&sodaToken=55372844-a01c-4f3b-a1ed-4f0cae0361c4
			//处理路径process.env.NODE_ENV
			// let hostUrl = process.env.NODE_ENV === 'development' ? 'crm-dev-pc' : 'crm'
			console.log('iframeUrl-------', this.iframeUrl)
			//通过URL或者数据，不能通过query，否则刷新数据出错
			if (!this.iframeUrl) {
				this.$message.error('iframeUrl--跳转路径有误！！')
				return
			}
			let tempObj = getQueryObj(decodeURIComponent(this.iframeUrl))
			if (this.validatenull(tempObj)) {
				this.$message.error('tempObj--跳转路径有误！！')
				return
			}
			console.log('tempObj----------', tempObj)
			//根据路径跳转不同的URL
			let {fromType = '', host = ''} = tempObj
			//路径
			let tempUrl = ''
			switch (fromType) {
				//投保批增
				case EnumInsureUrlType.insure:
					tempUrl = this.iframeUrl.replace('entryCenterUrl/insure', 'entryCenter')
					break
				case EnumInsureUrlType.add:
					tempUrl = this.iframeUrl.replace('entryCenterUrl/add', 'entryCenter')
					break
				case EnumInsureUrlType.change:
					tempUrl = this.iframeUrl.replace('insuranceCenter/entryCenterUrl/change', 'policy/endorseReplace')
					break
				//新增 修改被保人
				case EnumInsureUrlType.addInsured:
				case EnumInsureUrlType.editSingleInsured:
				//批量被保险人
				case EnumInsureUrlType.addMoreInsured:
				case EnumInsureUrlType.editMoreInsured:
					tempUrl = this.iframeUrl.replace('insuranceCenter/entryCenterUrl', 'policy/insured')
					break
			}
			if (!tempUrl) {
				this.$message.error('跳转路径有误！！')
				return
			}
			//拼接处理
			this.urlPath = `${host}/#${tempUrl}&type=entryCenterUrl&token=${this.access_token}&refreshToken=${this.refresh_token}&fromTypeChannel=bowei`
			// this.urlPath = `http://localhost:8080/#${tempUrl}&appId=1&type=entryCenterUrl&token=${this.access_token}&refreshToken=${this.refresh_token}`
			console.log('this.urlPath----', this.urlPath)
		},
		onReadyLoad() {
			//设置监听
			window.addEventListener('message', this.onDealMsg, false)
		},
		onDealMsg(event) {
			let {origin, data: msgData = {}} = event
			//处理数据
			let {type = '', msgType, orderId = '', tempId = '', applyId = ''} = msgData
			if (type === 'rrweb' || type === 'SELECTION-FROM-VOLCTX') {
				return
			}
			console.log('addEventListener---------', origin, msgData, this.iframeUrl, this.$route.fullPath)
			if (isBxJtMsg(origin) && this.iframeUrl === this.$route.fullPath) {
				switch (msgType) {
					case MessageEventType.initError:
						//错误提示返回
						this.$router.$avueRouter.closeTag()
						this.$router.go(-1)
						break
					case MessageEventType.anzeCheck:
						//安责核保
						this.$router.$avueRouter.closeTag()
						this.$router.push({
							path: this.$router.$avueRouter.getPath({
								src: '/insurance/policy/index',
							}),
							query: {
								status: 100,
							},
						})
						break
					case MessageEventType.policyDetail:
						//保单详情
						this.$router.push({
							path: this.$router.$avueRouter.getPath({
								src: `/policy/details/${orderId}`,
							}),
						})
						break
					case MessageEventType.xsmChange:
						//新市民切换引导
						this.$router.push({
							path: this.$router.$avueRouter.getPath({
								src: `/insuranceCenter/entryCenter/${tempId}`,
							}),
							query: msgData,
						})
						break
					case MessageEventType.payUrl:
						//支付链接
						payToHint(msgData)
						break
					case MessageEventType.changeSuccess:
						this.$router.$avueRouter.closeTag()
						this.$router.push({
							path: this.$router.$avueRouter.getPath({
								src: `/policy/details/${orderId}`,
							}),
						})
						break
					case MessageEventType.insuredResult:
						//被保险人
						if (!applyId) {
							this.$message.error('申请ID有误！')
							this.$router.$avueRouter.closeTag()
							this.$router.push({path: '/insurance/policy/index'})
							return
						}
						this.$router.$avueRouter.closeTag()
						this.$router.push({
							path: this.$router.$avueRouter.getPath({
								src: `/policy/surrender/detail/${applyId}`,
							}),
						})
						break
				}
			}
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {
		//清除监听
		window.removeEventListener('message', this.onDealMsg, false)
	},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped></style>
